export enum UserType {
  ADMIN = 'ADMIN',
  CELIA = 'CELIA',
  READER = 'READER',
  CORRECTIONS = 'CORRECTIONS',
  ORGANIZATION = 'ORGANIZATION',
  GUEST = 'GUEST',
}
